var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-icon',{attrs:{"type":"copy"},on:{"click":_vm.copyText}})
}
var staticRenderFns = []

export { render, staticRenderFns }